import { decode } from "html-entities";

interface MemoCellProps {
  title: string;
  memo?: string | null;
}

export function MemoCell({ title, memo }: MemoCellProps) {
  return (
    <>
      {memo && (
        <tbody>
          <tr>
            <td colSpan={2}>
              <div className={"pb-[0.75rem] font-bold"}>{title}</div>
              <div
                className={
                  "bg-base-200 rounded-md py-2 px-5 whitespace-pre-line"
                }
              >
                <p>{decode(memo)}</p>
              </div>
            </td>
          </tr>
        </tbody>
      )}
    </>
  );
}
